export default __webpack_public_path__ + "static/media/pdf.b881157d.svg";